/*
 * Loading ReCAPTCHA in the document head causes extremely low PageSpeed Insights score on mobile.
 * Here we load the ReCAPTCHA library when someone interacts with the form.
 * 
 */
document.addEventListener("DOMContentLoaded", function() {
    const nameInput = document.getElementById("name");

    if (nameInput) {
        // Add a focus event listener to the "name" input field
        nameInput.addEventListener("focus", function() {
            // Check if reCAPTCHA has already been loaded
            if (!window.grecaptcha) {
                // Dynamically load the reCAPTCHA script
                const recaptchaScript = document.createElement("script");
                recaptchaScript.src = "https://www.google.com/recaptcha/api.js";
                recaptchaScript.async = true;
                recaptchaScript.defer = true;
                document.head.appendChild(recaptchaScript);
            }
        }, { once: true }); // "once: true" ensures the script is loaded only once

    }
});